import Waveform from './Waveform'

export default Waveform
